<template>
  <div id="page-navigation-back-button" class="page-navigation-back-button">
    <button
      type="button"
      class="d-inline-flex btn btn-sm btn-light"
      onclick="history.back()"
      aria-label="Back"
    >
      <span
        class="
          png-icon png-icon-icons-glyph--k-carrot-back-title d-inline d-lg-none"
      ></span>
      <span
        class="
        png-icon png-icon-icons-glyph--k-arrow-left-sm d-none d-lg-inline"
      ></span>
      <span class="d-none d-lg-inline pl-1">
        {{ buttonText }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttonText: "Return back to previous page"
    };
  }
};
</script>
